import { Job } from "~/components/build/Show/lib/types";
import Icon from "~/components/shared/Icon";
import { SortFn } from ".";

function getQueueIcon(job: Job) {
  if (job.hosted) {
    return "heroicons/16/solid/cloud";
  }
  return "heroicons/16/solid/server-stack";
}

export function Queue({ job }: { job: Job }) {
  if (!job.clusterQueue) {
    return null;
  }

  return (
    <div className="flex items-center gap-1">
      <Icon icon={getQueueIcon(job)} className="block h-4 w-4 shrink-0 text-gray-800" />
      <a
        tabIndex={-1}
        href={job.agentsPath}
        // eslint-disable-next-line react/jsx-no-bind, id-length
        onClick={(e) => e.stopPropagation()}
        className="max-w-full truncate text-inherit hover:text-inherit focus:text-inherit"
      >
        {job.clusterQueue.key}
      </a>
    </div>
  );
}

// eslint-disable-next-line id-length
export const sortByQueue: SortFn = (direction) => (a, b) => {
  const aQueue = a.clusterQueue?.key || "";
  const bQueue = b.clusterQueue?.key || "";

  if (direction === "asc") {
    return aQueue.localeCompare(bQueue);
  }
  return bQueue.localeCompare(aQueue);
};
